import ShopPage from '../../components-v2/shops/ShopPage';
import { shops } from '../../config/shops';

export default ShopPage;

export function getStaticPaths({ locales }) {
  return {
    paths: (locales || ['ro']).flatMap(locale =>
      Object.keys(shops).map(city => ({ params: { city }, locale }))
    ),
    fallback: false,
  };
}

export function getStaticProps({ params }) {
  if (!Object.prototype.hasOwnProperty.call(shops, params.city)) return { notFound: true };
  return { props: { shop: shops[params.city] } };
}
